import { render, staticRenderFns } from "./YgUserList.vue?vue&type=template&id=1d080ae9&scoped=true"
import script from "./YgUserList.vue?vue&type=script&lang=js"
export * from "./YgUserList.vue?vue&type=script&lang=js"
import style0 from "./YgUserList.vue?vue&type=style&index=0&id=1d080ae9&prod&scoped=true&lang=scss"
import style1 from "./YgUserList.vue?vue&type=style&index=1&id=1d080ae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d080ae9",
  null
  
)

export default component.exports